var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",class:[
  'inline-flex items-center justify-center px-4 py-2 border text-sm font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 text-center transition-all cursor-pointer',
  _vm.type === 'secondary' ? 'bg-white text-indigo-600 border-solid border-indigo-600 hover:bg-gray-50 hover:border-indigo-700' : 'text-white bg-indigo-600 hover:bg-indigo-700 border-transparent',
  _vm.disabled ? 'opacity-50 pointer-events-none' : '',
],on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }